import { gql, useMutation } from '@apollo/client'

import type { ContactTypeT } from '@/components/Contact/SubjectContact'
import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const logContactMutation = gql`
  mutation logContact(
    $customerId: String!
    $userId: String!
    $sectionName: SectionName!
    $subjectId: String!
    $applicantContact: SubjectContact
    $refereeContact: SubjectContact
    $agentContact: AgentContact
  ) {
    logContact(
      customerId: $customerId
      userId: $userId
      sectionName: $sectionName
      subjectId: $subjectId
      applicantContact: $applicantContact
      refereeContact: $refereeContact
      agentContact: $agentContact
    )
  }
`

export type SubjectContact = {
  subjectId: string
  contactType: ContactTypeT
}

export type AgentContact = {
  contactType: ContactTypeT
}

export type SectionName = 'income' | 'residential'

export type MutationVars = {
  customerId: string
  userId: string
  sectionName: SectionName
  subjectId: string
  applicantContact?: SubjectContact
  refereeContact?: SubjectContact
  agentContact?: AgentContact
}

export type LogContactData = {
  logContact: string | unknown
}

export const useLogContactMutation: WrappedMutation<LogContactData, MutationVars> = () =>
  useMutation<LogContactData, MutationVars>(logContactMutation, {
    client: agentClient,
  })
